import { render, staticRenderFns } from "./about-idea.vue?vue&type=template&id=2cdc528a&scoped=true&"
import script from "./about-idea.vue?vue&type=script&lang=js&"
export * from "./about-idea.vue?vue&type=script&lang=js&"
import style0 from "./about-idea.vue?vue&type=style&index=0&id=2cdc528a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc528a",
  null
  
)

export default component.exports